import { SERVER_DATE_FORMAT } from "@constants/common";
import { timeDifferenceString } from "@utils/utils-client";
import moment from "moment";


export interface INotificationItem {
    id: number;
    type: NotificationType;
    content: string;
    contentHtml: string;
    data: any;
    isRead: boolean;
    relatedId: any;
    createDate: Date | null;
    isNew: boolean;
    timeIndicator: string;
    isApprovalRequestPending: boolean;
};

export class NotificationItem implements INotificationItem {
    id: number = 0;
    type: NotificationType = NotificationType.Common;
    content: string = "";
    contentHtml: string = "";
    data: any;
    isRead: boolean = false;
    relatedId: any;
    createDate: Date | null = null;
    isNew: boolean = false;
    timeIndicator: string = "";
    isApprovalRequestPending: boolean = true;

    constructor(initialFields: any = undefined) {
        if (initialFields) {
            Object.assign(this, initialFields);

            const serverDate = moment.utc(this.createDate, SERVER_DATE_FORMAT);
            this.timeIndicator = timeDifferenceString(serverDate, moment());

            this.isNew = this.timeIndicator?.endsWith('m') || this.timeIndicator?.endsWith('hr') || this.timeIndicator?.endsWith('now');

            if (this.data) {
                try {
                    this.data = JSON.parse(this.data);
                    if (this.type == NotificationType.BulkExcludeAccount && this.data && this.data.hasError && this.data.errorMessage) {
                        this.contentHtml = this.data.errorMessage;
                    }
                }
                catch {
                    return;
                }
            }
        }
    }
};

export enum NotificationType {
    Common = 0,
    RequestApproval = 1,
    BulkExcludeAccount = 2,
    ManuallyGenerateNoticesDocuments = 5,
};

export enum NotificationActionType {

    MarkAsRead = 1,
    Approve = 2,
    Open = 3,
    Download = 4,
};


